import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import React, { FC } from "react";
import { Document } from "../../PreAuth/PreAuthIhx/PreAuthIhx";

type DocumentUploadIhxProps = {
  documentTypes: Document[];
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType?: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks?: string | null;
  }[];
  handleFileChange: any;
  handleOpen: any;
};

const DocumentUploadEnhancement: FC<DocumentUploadIhxProps> = ({
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
}) => {
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "14px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Document Upload
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
        }}
      >
        {documentTypes
        ?.filter((docType: any) => docType?.label?.toUpperCase() !== "justification for enhancement"?.toUpperCase() )
        ?.map((docType: any) => {
          const matchingDocuments = documentUrls?.filter(
            (doc) => doc.documentLabelType === docType.label
          );

          return (
            <div
              key={docType.id}
              style={{
                border: "1px solid #eee",
                padding: 10,
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                // gap: 8,
              }}
            >

              <Upload
                multiple={docType?.multiple}
                showUploadList={false}
                beforeUpload={() => false}
                onChange={
                  handleFileChange && handleFileChange(docType?.labelId, docType?.multiple)
                }
              >
                <Button
                  icon={<UploadOutlined />}
                  style={{ display: "flex", alignItems: "center", borderRadius: 0, border: "none", borderTopLeftRadius: "6px", borderBottomLeftRadius: "6px" }}
                //   disabled={portalSubmission}
                ></Button>
              </Upload>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                style={{borderRadius: 0, border: "none", paddingLeft: 0, borderTopRightRadius: "6px", borderBottomRightRadius: "6px"}} 
                  iconPosition={"end"}
                  icon={
                    matchingDocuments?.length > 0 ? (
                      <EyeOutlined
                        style={{ marginLeft: "0.6rem" }}
                        onClick={() => {
                          handleOpen(matchingDocuments?.[0]?.documentLabelType, matchingDocuments?.[0]?.documentUrl);
                        }}
                      />
                    ) : (
                      <></>
                    )
                  }
                >
                  {docType.label}{" "}
                  {docType?.required ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : (
                    <></>
                  )}
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DocumentUploadEnhancement;
